import { httpRequest } from "../../utils/HttpRequest";
import { AuthUser, IUserFields } from "./LoginTypes";

class LoginService {
    //根据token拿到用户信息
    async getUser(params: { token: string; }) {
        const apiUrl = "/auth/login/verify";
        return await httpRequest
            .post<IUserFields>(apiUrl, params);
    }

    //账号密码登录
    async userLogin(user: AuthUser,config?: object) {
        const apiUrl = "/auth/login/login";
        return await httpRequest
            .post<string>(apiUrl, user, config);
    }
    /** 退出登录 */
    async userLogout() {
        const apiUrl = "/auth/login/logout";
        return await httpRequest
            .post<string>(apiUrl)
    }

}

export const loginService = new LoginService();
